var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Controller, useFieldArray, } from "react-hook-form";
import { useIntl, FormattedMessage } from "react-intl";
import { Row, Col, Button, Checkbox, MessageBanner, } from "@folio/stripes/components";
import { RecekTextField, RecekSelect } from "../inputs";
import { PublisherContactTypeEnum } from "../../types/Api";
import { InfoBox, InfoBoxTypeEnum } from "../InfoBox";
export var PublisherContactsSection = function (_a) {
    var _b, _c;
    var control = _a.control, errors = _a.errors;
    var formatMessage = useIntl().formatMessage;
    var _d = useFieldArray({
        control: control,
        name: "contacts",
    }), fields = _d.fields, append = _d.append, remove = _d.remove;
    var handleAddContact = function () {
        append({
            id: null,
            type: PublisherContactTypeEnum.EMAIL,
            value: "",
            info: "",
            isPrimary: false,
        });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(InfoBox, { type: InfoBoxTypeEnum.WARNING, customIcon: "\uD83D\uDCA1" },
            React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.publishers.edit.info.contacts" })),
        ((_c = (_b = errors.contacts) === null || _b === void 0 ? void 0 : _b.root) === null || _c === void 0 ? void 0 : _c.message) && (React.createElement("fieldset", { name: "contacts.root" },
            React.createElement(MessageBanner, { type: "error" }, errors.contacts.root.message))),
        fields.length === 0 ? (React.createElement("p", null,
            React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.publishers.edit.contacts.local.empty" }))) : (fields.map(function (field, index) { return (React.createElement(Row, { key: field.id },
            React.createElement(Col, { xs: 12, sm: 6, md: 2 },
                React.createElement(Controller, { control: control, name: "contacts.".concat(index, ".type"), render: function (_a) {
                        var controllerField = _a.field;
                        return (React.createElement(RecekSelect, __assign({}, controllerField, { labelId: "ui-br-legaldeposits.publishers.field.contacts.contactType", required: true, dataOptions: Object.values(PublisherContactTypeEnum).map(function (type) { return ({
                                value: type,
                                label: formatMessage({
                                    id: "ui-br-legaldeposits.publishers.contact.".concat(type),
                                }),
                            }); }) })));
                    } })),
            React.createElement(Col, { xs: 12, sm: 6, md: 4 },
                React.createElement(Controller, { control: control, name: "contacts.".concat(index, ".value"), render: function (_a) {
                        var _b, _c, _d;
                        var controllerField = _a.field;
                        return (React.createElement(RecekTextField, __assign({}, controllerField, { labelId: "ui-br-legaldeposits.publishers.field.contacts.contactValue", required: true, error: (_d = (_c = (_b = errors.contacts) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.value) === null || _d === void 0 ? void 0 : _d.message })));
                    } })),
            React.createElement(Col, { xs: 12, sm: 6, md: 4 },
                React.createElement(Controller, { control: control, name: "contacts.".concat(index, ".info"), render: function (_a) {
                        var _b;
                        var controllerField = _a.field;
                        return (React.createElement(RecekTextField, __assign({}, controllerField, { value: (_b = controllerField.value) !== null && _b !== void 0 ? _b : "", labelId: "ui-br-legaldeposits.publishers.field.contacts.contactInfo" })));
                    } })),
            React.createElement(Col, { xs: 12, sm: 6, md: 2 },
                React.createElement(Controller, { control: control, name: "contacts.".concat(index, ".isPrimary"), render: function (_a) {
                        var _b;
                        var controllerField = _a.field;
                        return (React.createElement(Checkbox, { checked: (_b = controllerField.value) !== null && _b !== void 0 ? _b : false, onChange: controllerField.onChange, label: formatMessage({
                                id: "ui-br-legaldeposits.publishers.field.contacts.isPrimary",
                            }) }));
                    } })),
            React.createElement(Col, { xs: 12 },
                React.createElement(Button, { buttonStyle: "danger", onClick: function () { return remove(index); } },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.button.remove" }))))); })),
        React.createElement(Row, null,
            React.createElement(Col, { xs: 12 },
                React.createElement(Button, { onClick: handleAddContact },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.publishers.edit.contacts.add" }))))));
};
